import { render, staticRenderFns } from "./ItemAttributeFilter.vue?vue&type=template&id=376b523d&scoped=true"
import script from "./ItemAttributeFilter.vue?vue&type=script&lang=ts"
export * from "./ItemAttributeFilter.vue?vue&type=script&lang=ts"
import style0 from "./ItemAttributeFilter.vue?vue&type=style&index=0&id=376b523d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b523d",
  null
  
)

export default component.exports